import React from 'react';
import QuestionnaireOverviewList from '../QuestionnaireOverview/QuestionnaireOverviewList';
// @ts-ignore
import styles from './QuestionnairePicker.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { Questionnaire } from '../../Interfaces/Questionnaire.interface';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';
import modal from '../../../../Components/Modal/Modal';

interface Props {
	onSelect: (questionnaire: SelectValue) => void;
	module?: QuestionnaireModule;
}

interface QuestionnairePickerListItem {
	item: Questionnaire;
	onSelect: () => void;
}

const QuestionnairePickerList: React.FC<Props> = ({ onSelect, module }) => {
	return (
		<QuestionnaireOverviewList
			module={module}
			renderItem={item => (
				<QuestionnairePickerListItem
					item={item}
					onSelect={() =>
						onSelect({
							value: item.id,
							label: item.title,
						})
					}
				/>
			)}
		/>
	);
};

const QuestionnairePickerListItem: React.FC<QuestionnairePickerListItem> = ({
	item,
	onSelect,
}) => {
	return (
		<div className={styles.item}>
			<div className={styles.title}>{item.title}</div>
			<div>
				<Button
					theme={Theme.GREEN}
					title='component.questionnairePicker.pick'
					onClick={onSelect}
				/>
			</div>
		</div>
	);
};

export default QuestionnairePickerList;
